













import { Component, Vue, Watch } from 'vue-property-decorator';
import globalx from '@/store/modules/globalx';
import userx from '@/store/modules/userx';
import assetx from '@/store/modules/assetx';
import { Global } from '@/store/globalz';
import { BgmManager } from '@/client/sound/BgmManager';
import { Tween } from '@/util/tweents';
import BlackPearlHome from '@/components/black/BlackPearlHome.vue';

@Component({
  components: {
    BlackPearlHome,
  },
})
export default class Home extends Vue {
  public get show() {
    return globalx.switch;
  }
  public mounted() {
    window.addEventListener('beforeunload', this.preventNav);
    window.addEventListener('unload', () => {});
  }
  public beforeDestroy() {
    window.removeEventListener('beforeunload', this.preventNav);
  }

  public async preventNav(event) {
    // if () {
    //   event.preventDefault();
    //   event.returnValue = '';
    // }
  }
  public async stopPageLeave() {}
  public get pageReady() {
    if (!globalx.maintenanceInfo) {
      return 'maintenanceCheck';
    }
    if (userx.loginStatus === 'loading') {
      return 'auth';
    }
    if (userx.loginStatus === 'logged in') {
      if (!globalx.userDocsReady) {
        return 'loadingUserDocs';
      }
    } else if (userx.loginStatus === 'logged out') {
      return 'redirect';
    }
    if (assetx.assetLoadState === 'completed') {
      return 'done';
    }
    return Math.round(assetx.assetLoadProgress);
  }
  @Watch('pageReady', { immediate: true })
  public pageReadyChanged(newVal: string) {
    switch (newVal) {
      case 'auth':
        this.$root.$emit('loading', 'Authenticating...');
        break;
      case 'loadingUserDocs':
        this.$root.$emit('loading', 'Loading  User  Data...');
        break;
      case 'maintenanceCheck':
        this.$root.$emit('loading', 'Checking  For  Update...');
        break;
      case 'done':
        this.$root.$emit('loading', '');
        break;
      case 'redirect':
        this.$router.push('/login');
        break;
      default:
        this.$root.$emit('loading', `Loading Assets...${newVal}%`);
        break;
    }
  }
}
